import React, { useState } from 'react';
import './search.scss';
import Input from '../../FormElements/Input';
import Button from '../../FormElements/Button';
import useHttpClient from '../../../hooks/useHttpClient';
import { setSearchResult } from '../../../../redux/search/search-actions';
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/alert/alert-actions';
import { MoonLoader } from "react-spinners";

const Search = ({ setSearchResult }) => {

  const [formData, setFormData] = useState({ searchValue: '' });

  const {isLoading, error, sendRequest} = useHttpClient();

  const handleChange = e => {
    const { name, value } = e.target

    setFormData({[name]: value});
  };

  const handleSubmit = async event => {

    event.preventDefault();

    let responseData;
    try {
      responseData = 
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/s/s/makeSearch`,
      'POST', JSON.stringify({ searchValue: formData.searchValue.toLowerCase() }),
      {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      });
      
      setSearchResult(responseData.usersList)

    }catch (err) {}
  }
  
  error && setAlert(error, 'Error');

  return (
      <form onSubmit={handleSubmit} className='search'  >
        <Input  
        id='searchValue' 
        name='searchValue' 
        type='input'
        onChange={handleChange}
        value={formData.searchValue}
        search
        style={{
          marginBottom: '0px', borderRight: 'none',
          borderBottomRightRadius: '0px',
          borderTopRightRadius: '0px',
          background: 'white', borderColor: 'grey',
          // width: '50px'
        }}
        // autoComplete='off'
        mainStyle={{width: 'auto'}}
        />
        <Button className='button'
        style={{
          height: '32px', borderLeft: 'none',
          borderBottomLeftRadius: '0px',
          borderTopLeftRadius: '0px',
          borderColor: 'grey', background: 'white'
        }}
        type='submit'
        disabled={isLoading || formData.searchValue.length === 0}
        >
          {isLoading ? (<MoonLoader size='13' />) : (<i className="search icon"></i>)}
        </Button>
      </form>      
    // </div> 
  )
}


export default connect(null, { setSearchResult })(Search);